<template>
  <v-container fluid grid-list-sm v-if="announcement.text">
    <v-layout row wrap>
      <v-flex>
        <v-alert :color="announcement.type" :icon="announcement.icon" value="true" :dismissible="announcement.dismissible" v-model="alert">
          <span v-html="announcement.text" />
        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  export default {
    name: 'AnnouncementsBar',
    data () {
      return {
        alert: true,
        announcement: this.$store.getters.externalData.announcement
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/AnnouncementsBar.vue